import { winnersURL } from "../helpers/paths";
import {
  brandfeatures,
  earlyaccess,
  exclusivecollab,
  fbicon,
  images,
  instaicon,
  vouchersprizes,
  yticon,
} from "../source";

export const programRulesData = [
  {
    title: "Eligibility",
    desc: [
      `Open to individuals with an active and public Instagram profile.`,
      "Registration opens at 5:00 PM on the 10th of each month and closes at 5:00 PM on the 10th of the following month for each cycle.",
    ],
  },
  {
    title: "Content Requirements",
    desc: [
      "Post at least one video each month featuring Everest Spices. Ensure you tag the program page and include the mandatory hashtags.",
    ],
  },
  {
    title: "Engagement Rules",
    desc: [
      "Only genuine organic engagement will be considered. Engagement generated through bots, paid amplification, fake accounts, automated services, or any inorganic means shall be liable for disqualification.",
    ],
  },
  {
    title: "Brand Discretion",
    desc: [
      "The management reserves the right to terminate any participant suspected of inorganic, manipulated, automated or suspicious engagement activity, whether or not conclusive evidence is publicly disclosed.",
    ],
  },
  {
    title: "Qualification and Gratification",
    desc: [
      "Meeting engagement thresholds does not automatically guarantee selection, qualification, or gratification. All results remain subject to verification and at the discretion of the management.",
    ],
  },
];

export const states = [
  { value: "maharashtra", label: "Maharashtra" },
  { value: "karnatak", label: "Karnatak" },
  { value: "bangluru", label: "Bangluru" },
];

export const cities = [
  { value: "mumbai", label: "Mumbai" },
  { value: "thane", label: "Thane" },
  { value: "ratnagiri", label: "Ratnagiri" },
];

export const perksData = [
  {
    icon: earlyaccess,
    title: "Early Product Access",
    desc: "A sneak peek at Everest's latest spice innovations.",
    titleClass: "perk_title_icon_1",
  },
  {
    icon: vouchersprizes,
    title: "Vouchers & Prizes",
    desc: "Hit milestones & unlock exciting rewards.",
  },
  {
    icon: exclusivecollab,
    title: "Exclusive Collaborations",
    desc: "Participate in limited-time collaborations with us.",
    titleClass: "perk_title_icon_3",
  },
  {
    icon: brandfeatures,
    title: "Brand Features",
    desc: "Be showcased across Everest's social platforms.",
  },
];

export const termsData = [
  {
    tabName: "demo tab",
    data: [
      {
        title: "demo title",
        description: "demo description",
      },
    ],
  },
];
export const socialsData = [
  {
    icon: instaicon,
    url: "https://www.instagram.com/everest_tastemasters/",
  },
  // {
  //   icon: fbicon,
  //   url: "https://www.facebook.com/@everestspices",
  // },
  // {
  //   icon: yticon,
  //   url: "https://www.youtube.com/@everestspices2874",
  // },
];

export const privacyData = [
  {
    heading: "demo heading",
    description: "demo description",
  },
];

export const homeBannerData = [
  // {
  //   img: images.homeBanner04.img,
  //   imgMb: images.homeBannerMb04.img,
  // },
  {
    img: images.homeBanner03.img,
    imgMb: images.homeBannerMb03.img,
  },
  {
    // img: [images.homeBanner01.img],
    img: images.homeBanner01.img,
    imgMb: images.homeBannerMb01.img,
    link: winnersURL,
  },
  {
    // img: [images.homeBanner02.img, images.homeBanner02_1.img],
    img: images.homeBanner02.img,
    imgMb: images.homeBannerMb02.img,
  },
];

export const winnersList = [
  {
    name: "Aarti Tale",
    month: "February",
    year: 2025,
    prize: "iPhone 16",
    views: "23,029,931",
  },
  {
    name: "Savita Pravin Wankhede",
    month: "February",
    year: 2025,
    prize: "500 Amazon Voucher",
    views: "23,200",
  },
  {
    name: "Aina Shaheen",
    month: "March",
    year: 2025,
    prize: "5k Home Appliance",
    views: "70,697",
  },
  {
    name: "Sameera Begum",
    month: "March",
    year: 2025,
    prize: "5k Home Appliance",
    views: "58,770",
  },
  {
    name: "Bharati Vijay Vahagaonkar",
    month: "March",
    year: 2025,
    prize: "5k Home Appliance",
    views: "50,278",
  },
  {
    name: "Sonal Patel",
    month: "March",
    year: 2025,
    prize: "2k Amazon Voucher",
    views: "32,688",
  },
  {
    name: "Neha Kumari",
    month: "March",
    year: 2025,
    prize: "500 Amazon Voucher",
    views: "17,443",
  },
  {
    name: "Gayatri Neog",
    month: "April",
    year: 2025,
    prize: "20k Home Appliance",
    views: "426,991",
  },
  {
    name: "Aarti Tale",
    month: "April",
    year: 2025,
    prize: "5k Home Appliance",
    views: "118,078",
  },
  {
    name: "Savita Pravin Wankhede",
    month: "April",
    year: 2025,
    prize: "5k Home Appliance",
    views: "82,093",
  },
  {
    name: "Bharati Vijay Vahagaonkar",
    month: "April",
    year: 2025,
    prize: "2k Amazon Voucher",
    views: "112,423",
  },
  {
    name: "Savita Singarya",
    month: "April",
    year: 2025,
    prize: "2k Amazon Voucher",
    views: "31,176",
  },
  {
    name: "Bharati Vahagaonkar",
    month: "May",
    year: 2025,
    prize: "50k Home Appliance",
    views: "836,460",
  },
  {
    name: "Aarti Arke",
    month: "May",
    year: 2025,
    prize: "50k Home Appliance",
    views: "716,832",
  },
  {
    name: "Sakshi Thakur",
    month: "May",
    year: 2025,
    prize: "5k Home Appliance",
    views: "131,052",
  },
  {
    name: "Naziya Sultan Khan",
    month: "May",
    year: 2025,
    prize: "5k Home Appliance",
    views: "111,436",
  },
  {
    name: "Savita Singarya",
    month: "May",
    year: 2025,
    prize: "5k Home Appliance",
    views: "99,399",
  },
  {
    name: "Zikra Rana",
    month: "June",
    year: 2025,
    prize: "50k Home Appliance",
    views: "632,753",
  },
  {
    name: "Radhika Trivedi",
    month: "June",
    year: 2025,
    prize: "50k Home Appliance",
    views: "519,030",
  },
  {
    name: "Aarti Arke",
    month: "June",
    year: 2025,
    prize: "20k Home Appliance",
    views: "4,100,143",
  },
  {
    name: "Sakshi Thakur",
    month: "June",
    year: 2025,
    prize: "20k Home Appliance",
    views: "318,316",
  },
  {
    name: "Bharati Vahagaonkar",
    month: "June",
    year: 2025,
    prize: "20k Home Appliance",
    views: "309,341",
  },
  {
    name: "Zikra Rana",
    month: "July",
    year: 2025,
    prize: "iPhone 16",
    views: "9,160,125",
  },
  {
    name: "Lekhani Patel",
    month: "July",
    year: 2025,
    prize: "50k Home Appliance",
    views: "1,566,109",
  },
  {
    name: "Sakshi Thakur",
    month: "July",
    year: 2025,
    prize: "50k Home Appliance",
    views: "932,086",
  },
  {
    name: "Dhiraj Pokale",
    month: "July",
    year: 2025,
    prize: "50k Home Appliance",
    views: "697,027",
  },
  {
    name: "Savita Wankhede",
    month: "July",
    year: 2025,
    prize: "20k Home Appliance",
    views: "273,404",
  },
  {
    name: "Bharati Vahagaonkar",
    month: "August",
    year: 2025,
    prize: "iPhone 16",
    views: "5,070,751",
  },
  {
    name: "Wankhede Savita",
    month: "August",
    year: 2025,
    prize: "50k Home Appliance",
    views: "802,346",
  },
  {
    name: "Sayandeep Roy",
    month: "August",
    year: 2025,
    prize: "50k Home Appliance",
    views: "503,166",
  },
  {
    name: "Rakhi Nilesh Bhagat",
    month: "August",
    year: 2025,
    prize: "20k Home Appliance",
    views: "317,998",
  },
  {
    name: "Dhiraj Pokale",
    month: "August",
    year: 2025,
    prize: "20k Home Appliance",
    views: "302,323",
  },
  {
    name: "Krishna Jiyani",
    month: "September",
    year: 2025,
    prize: "50k Home Appliance",
    views: "2,251,313",
  },
  {
    name: "Aishwarya Dilip Padwal",
    month: "September",
    year: 2025,
    prize: "50k Home Appliance",
    views: "557,955",
  },
  {
    name: "Zikra Rana",
    month: "September",
    year: 2025,
    prize: "20k Home Appliance",
    views: "726,055",
  },
  {
    name: "Honey Lalwani",
    month: "September",
    year: 2025,
    prize: "5k Home Appliance",
    views: "185,965",
  },
  {
    name: "Nayana Liladhar Kurkure",
    month: "September",
    year: 2025,
    prize: "5k Home Appliance",
    views: "61,478",
  },
  {
    name: "Yogita Vanwe",
    month: "October",
    year: 2025,
    prize: "iPhone 16",
    views: "10,961,340",
  },
  {
    name: "Anuja",
    month: "October",
    year: 2025,
    prize: "50k Home Appliance",
    views: "3,736,157",
  },
  {
    name: "Manoj Dudi",
    month: "October",
    year: 2025,
    prize: "50k Home Appliance",
    views: "3,045,327",
  },
  {
    name: "Suman Popat Gite",
    month: "October",
    year: 2025,
    prize: "50k Home Appliance",
    views: "2,316,531",
  },
  {
    name: "Bharti Rokade",
    month: "October",
    year: 2025,
    prize: "50k Home Appliance",
    views: "1,533,433",
  },
  {
    name: "Lubna Shaheen",
    month: "November",
    year: 2025,
    prize: "50k Home Appliance",
    views: "1,873,047",
  },
  {
    name: "Vanwe Yogita Vishal",
    month: "November",
    year: 2025,
    prize: "50k Home Appliance",
    views: "1,732,120",
  },
  {
    name: "Shahzadi Shabnam",
    month: "November",
    year: 2025,
    prize: "50k Home Appliance",
    views: "1,702,394",
  },
  {
    name: "Mubashshra Khan",
    month: "November",
    year: 2025,
    prize: "50k Home Appliance",
    views: "1,414,845",
  },
  {
    name: "Aarti Meshram",
    month: "November",
    year: 2025,
    prize: "50k Home Appliance",
    views: "572,928",
  },
  {
    name: "Sima Dahifale",
    month: "December",
    year: 2025,
    prize: "50k Home Appliance",
    views: "1,397,065",
  },
  {
    name: "Munisha Patel",
    month: "December",
    year: 2025,
    prize: "50k Home Appliance",
    views: "551,180",
  },
  {
    name: "Naina Agarwal",
    month: "December",
    year: 2025,
    prize: "50k Home Appliance",
    views: "514,513",
  },
  {
    name: "Lubna Shaheen",
    month: "December",
    year: 2025,
    prize: "20k Home Appliance",
    views: "3,943,581",
  },
  {
    name: "Yogita Vanwe",
    month: "December",
    year: 2025,
    prize: "20k Home Appliance",
    views: "2,938,293",
  },
  {
    name: "Amruta Marathe",
    month: "January",
    year: 2026,
    prize: "iPhone 16",
    views: "5,631,405",
  },
  {
    name: "Asiya Sana",
    month: "January",
    year: 2026,
    prize: "iPhone 16",
    views: "5,606,598",
  },
  {
    name: "Kishan Swaminathan Nishad",
    month: "January",
    year: 2026,
    prize: "50k Home Appliance",
    views: "3,610,548",
  },
  {
    name: "Karishma Sayyad",
    month: "January",
    year: 2026,
    prize: "50k Home Appliance",
    views: "2,454,742",
  },
  {
    name: "Minakshi Borana",
    month: "January",
    year: 2026,
    prize: "50k Home Appliance",
    views: "660,737",
  },
  {
    name: "Suman Gite",
    month: "February",
    year: 2026,
    prize: "iPhone 16",
    views: "13,934,199",
  },
  {
    name: "Manoj Dudi",
    month: "February",
    year: 2026,
    prize: "iPhone 16",
    views: "7,447,857",
  },
  {
    name: "Ayodhya Mahesh",
    month: "February",
    year: 2026,
    prize: "50k Home Appliance",
    views: "3,013,670",
  },
  {
    name: "Laxmi Mahesh Bhosale",
    month: "February",
    year: 2026,
    prize: "50k Home Appliance",
    views: "1,428,349",
  },
  {
    name: "Jaylaxmi Madgundi",
    month: "February",
    year: 2026,
    prize: "50k Home Appliance",
    views: "1,191,869",
  },
  {
    name: "Mohammed Faisal Mohammed Yunus",
    month: "March",
    year: 2026,
    prize: "iPhone 16",
    views: "8,212,930",
  },
  {
    name: "Swaraj Ghule",
    month: "March",
    year: 2026,
    prize: "iPhone 16",
    views: "6,705,178",
  },
  {
    name: "Shamim",
    month: "March",
    year: 2026,
    prize: "50k Home Appliance",
    views: "3,138,435",
  },
  {
    name: "Supriya Amrutsagar",
    month: "March",
    year: 2026,
    prize: "50k Home Appliance",
    views: "1,771,527",
  },
  {
    name: "Shaik Samreen",
    month: "March",
    year: 2026,
    prize: "50k Home Appliance",
    views: "1,585,947",
  },
  {
    name: "Akanksha Patil",
    month: "April",
    year: 2026,
    prize: "50k Home Appliance",
    views: "5,407,635",
  },
  {
    name: "Ruby singh",
    month: "April",
    year: 2026,
    prize: "50k Home Appliance",
    views: "2,490,508",
  },
  {
    name: "Poonam Pawar",
    month: "April",
    year: 2026,
    prize: "50k Home Appliance",
    views: "2,220,242",
  },
  {
    name: "Megha Gupta",
    month: "April",
    year: 2026,
    prize: "50k Home Appliance",
    views: "1,800,385",
  },
  {
    name: "Devikunwar Rajpurohit",
    month: "April",
    year: 2026,
    prize: "50k Home Appliance",
    views: "1,549,203",
  },

  // May 2026 Winners Data
  {
    name: "Shikha Mishra",
    month: "May",
    year: 2026,
    prize: "iPhone 16",
    views: "18,307,295",
  },
  {
    name: "Munisha Patel",
    month: "May",
    year: 2026,
    prize: "iPhone 16",
    views: "7,630,549",
  },
  {
    name: "Amisha Singh",
    month: "May",
    year: 2026,
    prize: "50k Home Appliance",
    views: "4,901,724",
  },
  {
    name: "Ashwini Rakesh Jagtap",
    month: "May",
    year: 2026,
    prize: "50k Home Appliance",
    views: "1,864,377",
  },
  {
    name: "Manisha",
    month: "May",
    year: 2026,
    prize: "50k Home Appliance",
    views: "1,602,641",
  },
  {
    name: "Akanksha Patil",
    month: "May",
    year: 2026,
    prize: "20k Home Appliance",
    views: "1,639,111",
  },
  {
    name: "Megha Gupta",
    month: "May",
    year: 2026,
    prize: "20k Home Appliance",
    views: "1,382,671",
  },
  {
    name: "Shamim",
    month: "May",
    year: 2026,
    prize: "20k Home Appliance",
    views: "1,250,801",
  },
  {
    name: "Vaishnavi Sambhaji",
    month: "May",
    year: 2026,
    prize: "5k Home Appliance",
    views: "481,093",
  },
  {
    name: "Ruby Rajpoot",
    month: "May",
    year: 2026,
    prize: "5k Home Appliance",
    views: "289,658",
  },
  {
    name: "Asha Avhad",
    month: "May",
    year: 2026,
    prize: "5k Home Appliance",
    views: "234,878",
  },
  {
    name: "Reeena Jhanjoter",
    month: "May",
    year: 2026,
    prize: "5k Home Appliance",
    views: "222,019",
  },
  {
    name: "Kulsum",
    month: "May",
    year: 2026,
    prize: "5k Home Appliance",
    views: "211,424",
  },
  {
    name: "Lavina Asrani",
    month: "May",
    year: 2026,
    prize: "5k Home Appliance",
    views: "208,762",
  },
  {
    name: "Radhika Kumari",
    month: "May",
    year: 2026,
    prize: "5k Home Appliance",
    views: "183,041",
  },
  {
    name: "Khyati Dhaval Chauhan",
    month: "May",
    year: 2026,
    prize: "5k Home Appliance",
    views: "180,296",
  },
  {
    name: "Richika Suryavanshi",
    month: "May",
    year: 2026,
    prize: "5k Home Appliance",
    views: "139,663",
  },
  {
    name: "Rana Tabassum",
    month: "May",
    year: 2026,
    prize: "5k Home Appliance",
    views: "134,966",
  },
  {
    name: "Ayodhya Bansode",
    month: "May",
    year: 2026,
    prize: "2k Amazon Voucher",
    views: "1,504,376",
  },
  {
    name: "Durga Balaji Shinde",
    month: "May",
    year: 2026,
    prize: "2k Amazon Voucher",
    views: "1,200,781",
  },
  {
    name: "Soni Kohli",
    month: "May",
    year: 2026,
    prize: "2k Amazon Voucher",
    views: "475,304",
  },
  {
    name: "Rufiya Adeem Kazi",
    month: "May",
    year: 2026,
    prize: "2k Amazon Voucher",
    views: "315,293",
  },
  {
    name: "Sonali Patil",
    month: "May",
    year: 2026,
    prize: "2k Amazon Voucher",
    views: "271,464",
  },
  {
    name: "Minakshi Borana",
    month: "May",
    year: 2026,
    prize: "2k Amazon Voucher",
    views: "253,889",
  },
  {
    name: "Honey Shaikh",
    month: "May",
    year: 2026,
    prize: "2k Amazon Voucher",
    views: "240,957",
  },
  {
    name: "Meghan Santosh Thombare",
    month: "May",
    year: 2026,
    prize: "2k Amazon Voucher",
    views: "121,568",
  },
  {
    name: "Kalyani Bhoite",
    month: "May",
    year: 2026,
    prize: "2k Amazon Voucher",
    views: "94,103",
  },
  {
    name: "Zeba Khan",
    month: "May",
    year: 2026,
    prize: "2k Amazon Voucher",
    views: "87,301",
  },

  // June 2026 Winners Data
  {
    name: "Lekhni Patel",
    month: "June",
    year: 2026,
    prize: "iPhone 16",
    views: "53,187,684",
  },
  {
    name: "Mubashra",
    month: "June",
    year: 2026,
    prize: "iPhone 16",
    views: "21,030,360",
  },
  {
    name: "Shamim",
    month: "June",
    year: 2026,
    prize: "iPhone 16",
    views: "11,751,157",
  },
  {
    name: "Sunil Kumar Patidar",
    month: "June",
    year: 2026,
    prize: "30k Gift Reward",
    views: "5,921,344",
  },
  {
    name: "Godavari Bapurao Gaikwad",
    month: "June",
    year: 2026,
    prize: "30k Gift Reward",
    views: "5,614,762",
  },
  {
    name: "Afreen Aino Shaikh",
    month: "June",
    year: 2026,
    prize: "30k Gift Reward",
    views: "5,412,294",
  },
  {
    name: "Aaisha Salman",
    month: "June",
    year: 2026,
    prize: "10k Gift Reward",
    views: "1,221,014",
  },
  {
    name: "Aishwarya Padwal",
    month: "June",
    year: 2026,
    prize: "10k Gift Reward",
    views: "1,147,563",
  },
  {
    name: "Poonam Vishwakarma",
    month: "June",
    year: 2026,
    prize: "10k Gift Reward",
    views: "934,256",
  },
  {
    name: "Baishnabi Parida",
    month: "June",
    year: 2026,
    prize: "5k Gift Reward",
    views: "493,407",
  },
  {
    name: "Ashwini Bhagirath Patil",
    month: "June",
    year: 2026,
    prize: "5k Gift Reward",
    views: "446,334",
  },
  {
    name: "Yasmeen Harun Shaikh",
    month: "June",
    year: 2026,
    prize: "5k Gift Reward",
    views: "377,376",
  },
  {
    name: "Kalyani Bhoite",
    month: "June",
    year: 2026,
    prize: "5k Gift Reward",
    views: "333,041",
  },
  {
    name: "Shubha Gaikwad",
    month: "June",
    year: 2026,
    prize: "5k Gift Reward",
    views: "276,276",
  },
  {
    name: "Zeba Khan",
    month: "June",
    year: 2026,
    prize: "5k Gift Reward",
    views: "263,133",
  },
  {
    name: "Anjali Sinha",
    month: "June",
    year: 2026,
    prize: "5k Gift Reward",
    views: "260,458",
  },
  {
    name: "Priya Prashant Yadav",
    month: "June",
    year: 2026,
    prize: "5k Gift Reward",
    views: "218,696",
  },
  {
    name: "Daraksha Kadri",
    month: "June",
    year: 2026,
    prize: "5k Gift Reward",
    views: "182,988",
  },
  {
    name: "Varsha Yalamarthi",
    month: "June",
    year: 2026,
    prize: "5k Gift Reward",
    views: "123,634",
  },
  {
    name: "Sima Dahifale",
    month: "June",
    year: 2026,
    prize: "2k Gift Reward",
    views: "2,263,334",
  },
  {
    name: "Rashmi Dalvi",
    month: "June",
    year: 2026,
    prize: "2k Gift Reward",
    views: "268,623",
  },
  {
    name: "Krishna Jyoti Narzary",
    month: "June",
    year: 2026,
    prize: "2k Gift Reward",
    views: "231,446",
  },
  {
    name: "Kulsum Khatri",
    month: "June",
    year: 2026,
    prize: "2k Gift Reward",
    views: "157,543",
  },
  {
    name: "Kommula Mounika",
    month: "June",
    year: 2026,
    prize: "2k Gift Reward",
    views: "123,662",
  },
  {
    name: "Supriya Amrutsagar",
    month: "June",
    year: 2026,
    prize: "2k Gift Reward",
    views: "88,845",
  },
  {
    name: "Ashwini Bhosale",
    month: "June",
    year: 2026,
    prize: "2k Gift Reward",
    views: "86,799",
  },
  {
    name: "Huma Shaikh",
    month: "June",
    year: 2026,
    prize: "2k Gift Reward",
    views: "77,739",
  },
  {
    name: "Rukhsana Shaikh",
    month: "June",
    year: 2026,
    prize: "2k Gift Reward",
    views: "77,481",
  },
  {
    name: "Deepa Hegde",
    month: "June",
    year: 2026,
    prize: "2k Gift Reward",
    views: "75,992",
  },

  // July 2026 Winners Data
  {
    name: "Kulsum Khatri",
    month: "July",
    year: 2026,
    prize: "iPhone 16",
    views: "34,963,671",
  },
  {
    name: "Shobha Sharma",
    month: "July",
    year: 2026,
    prize: "iPhone 16",
    views: "13,999,839",
  },
  {
    name: "Dr Shweta Doshi",
    month: "July",
    year: 2026,
    prize: "iPhone 16",
    views: "6,822,686",
  },
  {
    name: "Honey Shaikh",
    month: "July",
    year: 2026,
    prize: "30k Gift Reward",
    views: "5,012,257",
  },
  {
    name: "Goldie Sharma",
    month: "July",
    year: 2026,
    prize: "30k Gift Reward",
    views: "4,741,419",
  },
  {
    name: "Mohd Shahzeb",
    month: "July",
    year: 2026,
    prize: "30k Gift Reward",
    views: "4,720,457",
  },
  {
    name: "Ruby Singh",
    month: "July",
    year: 2026,
    prize: "10k Gift Reward",
    views: "2,483,118",
  },
  {
    name: "Godavari Gaikwad",
    month: "July",
    year: 2026,
    prize: "10k Gift Reward",
    views: "1,036,662",
  },
  {
    name: "Bhavana Ghodke",
    month: "July",
    year: 2026,
    prize: "10k Gift Reward",
    views: "926,821",
  },
  {
    name: "Supriya Amrutsagar",
    month: "July",
    year: 2026,
    prize: "5k Gift Reward",
    views: "553,364",
  },
  {
    name: "Alka Gambhir",
    month: "July",
    year: 2026,
    prize: "5k Gift Reward",
    views: "485,947",
  },
  {
    name: "Shabana Shaikh",
    month: "July",
    year: 2026,
    prize: "5k Gift Reward",
    views: "384,134",
  },
  {
    name: "Manisha Anil Patil",
    month: "July",
    year: 2026,
    prize: "5k Gift Reward",
    views: "371,462",
  },
  {
    name: "Pratibha Dashpute",
    month: "July",
    year: 2026,
    prize: "5k Gift Reward",
    views: "314,827",
  },
  {
    name: "Aaisha Salman",
    month: "July",
    year: 2026,
    prize: "5k Gift Reward",
    views: "279,386",
  },
  {
    name: "Neetu",
    month: "July",
    year: 2026,
    prize: "5k Gift Reward",
    views: "237,333",
  },
  {
    name: "Neena Rani Mishra",
    month: "July",
    year: 2026,
    prize: "5k Gift Reward",
    views: "192,265",
  },
  {
    name: "Sumera Khatri",
    month: "July",
    year: 2026,
    prize: "5k Gift Reward",
    views: "174,986",
  },
  {
    name: "Vandana Shital Masutage",
    month: "July",
    year: 2026,
    prize: "5k Gift Reward",
    views: "163,355",
  },
  {
    name: "Manisha Rajpurohit",
    month: "July",
    year: 2026,
    prize: "2k Gift Reward",
    views: "3,965,364",
  },
  {
    name: "Richika Suryavanshi",
    month: "July",
    year: 2026,
    prize: "2k Gift Reward",
    views: "492,249",
  },
  {
    name: "Priyanka Tushar Pawar",
    month: "July",
    year: 2026,
    prize: "2k Gift Reward",
    views: "231,279",
  },
  {
    name: "Varsha Yalamarthi",
    month: "July",
    year: 2026,
    prize: "2k Gift Reward",
    views: "91,896",
  },
  {
    name: "Jyoti Singh",
    month: "July",
    year: 2026,
    prize: "2k Gift Reward",
    views: "91,656",
  },
  {
    name: "Daraksha Kadri",
    month: "July",
    year: 2026,
    prize: "2k Gift Reward",
    views: "90,844",
  },
  {
    name: "Sonal Rasik Sawant",
    month: "July",
    year: 2026,
    prize: "2k Gift Reward",
    views: "90,622",
  },
  {
    name: "Komal Purohit",
    month: "July",
    year: 2026,
    prize: "2k Gift Reward",
    views: "87,627",
  },
  {
    name: "Smita Rishikant More",
    month: "July",
    year: 2026,
    prize: "2k Gift Reward",
    views: "85,055",
  },
  {
    name: "Saba Asif",
    month: "July",
    year: 2026,
    prize: "2k Gift Reward",
    views: "84,933",
  },

  // August 2026 Winners Data
  {
    name: "Aarti Tale",
    month: "February",
    year: 2025,
    prize: "iPhone 16",
    views: "23,029,931",
  },
  {
    name: "Krishna Choudhary",
    month: "August",
    year: 2026,
    prize: "iPhone 16",
    views: "35,418,092",
  },
  {
    name: "Shahzadi Shabnam",
    month: "August",
    year: 2026,
    prize: "iPhone 16",
    views: "10,066,078",
  },
  {
    name: "Mohd Shahzeb",
    month: "August",
    year: 2026,
    prize: "iPhone 16",
    views: "9,063,818",
  },
  {
    name: "Mohd Ashraf",
    month: "August",
    year: 2026,
    prize: "30k Gift Reward",
    views: "5,073,054",
  },
  {
    name: "Salma Naushad",
    month: "August",
    year: 2026,
    prize: "30k Gift Reward",
    views: "4,757,564",
  },
  {
    name: "Abdulraoufqadri Khatri",
    month: "August",
    year: 2026,
    prize: "30k Gift Reward",
    views: "4,636,891",
  },
  {
    name: "Shaik Samreen",
    month: "August",
    year: 2026,
    prize: "10k Gift Reward",
    views: "5,340,480",
  },
  {
    name: "Zeba Khan",
    month: "August",
    year: 2026,
    prize: "10k Gift Reward",
    views: "3,455,947",
  },
  {
    name: "Mona Reddy",
    month: "August",
    year: 2026,
    prize: "10k Gift Reward",
    views: "1,124,121",
  },
  {
    name: "Dhanashri Shinde",
    month: "August",
    year: 2026,
    prize: "5k Gift Reward",
    views: "459,857",
  },
  {
    name: "Shama Parveen",
    month: "August",
    year: 2026,
    prize: "5k Gift Reward",
    views: "366,342",
  },
  {
    name: "Jyotima Pravin Singh",
    month: "August",
    year: 2026,
    prize: "5k Gift Reward",
    views: "356,449",
  },
  {
    name: "Kalpana Ghule",
    month: "August",
    year: 2026,
    prize: "5k Gift Reward",
    views: "323,529",
  },
  {
    name: "Madhu",
    month: "August",
    year: 2026,
    prize: "5k Gift Reward",
    views: "252,005",
  },
  {
    name: "Riya Kumari",
    month: "August",
    year: 2026,
    prize: "5k Gift Reward",
    views: "230,109",
  },
  {
    name: "Sayma Bano",
    month: "August",
    year: 2026,
    prize: "5k Gift Reward",
    views: "219,368",
  },
  {
    name: "Farah khan",
    month: "August",
    year: 2026,
    prize: "5k Gift Reward",
    views: "214,777",
  },
  {
    name: "Sneha",
    month: "August",
    year: 2026,
    prize: "5k Gift Reward",
    views: "191,044",
  },
  {
    name: "Rukhsana Shaikh",
    month: "August",
    year: 2026,
    prize: "5k Gift Reward",
    views: "182,003",
  },
  {
    name: "Ekta Gupta",
    month: "August",
    year: 2026,
    prize: "2k Gift Reward",
    views: "870,589",
  },
  {
    name: "Ashwini Bhagirath Patil",
    month: "August",
    year: 2026,
    prize: "2k Gift Reward",
    views: "499,138",
  },
  {
    name: "Yasmeen Shaikh",
    month: "August",
    year: 2026,
    prize: "2k Gift Reward",
    views: "275,935",
  },
  {
    name: "Vandana Shital Masutage",
    month: "August",
    year: 2026,
    prize: "2k Gift Reward",
    views: "258,979",
  },
  {
    name: "Baishnabi Parida",
    month: "August",
    year: 2026,
    prize: "2k Gift Reward",
    views: "245,626",
  },
  {
    name: "Jayashri Magar",
    month: "August",
    year: 2026,
    prize: "2k Gift Reward",
    views: "234,580",
  },
  {
    name: "Sumera Khatri",
    month: "August",
    year: 2026,
    prize: "2k Gift Reward",
    views: "212,548",
  },
  {
    name: "Laveenaasrani",
    month: "August",
    year: 2026,
    prize: "2k Gift Reward",
    views: "97,133",
  },
  {
    name: "Shaik Aiesha",
    month: "August",
    year: 2026,
    prize: "2k Gift Reward",
    views: "96,481",
  },
  {
    name: "Ruby Afaq Ahmed",
    month: "August",
    year: 2026,
    prize: "2k Gift Reward",
    views: "89,259",
  },

  // September 2026 Winners Data
  {
    name: "Pooja Jain",
    month: "September",
    year: 2026,
    prize: "iPhone 16",
    views: "14,113,678",
  },
  {
    name: "Puja Saha",
    month: "September",
    year: 2026,
    prize: "iPhone 16",
    views: "7,927,620",
  },
  {
    name: "Priyanka Gupta",
    month: "September",
    year: 2026,
    prize: "iPhone 16",
    views: "6,791,659",
  },
  {
    name: "Parvati Vishwakarma",
    month: "September",
    year: 2026,
    prize: "30k Gift Reward",
    views: "3,197,697",
  },
  {
    name: "Kiran Choudhary",
    month: "September",
    year: 2026,
    prize: "30k Gift Reward",
    views: "3,148,449",
  },
  {
    name: "Vaishnavi Buktare",
    month: "September",
    year: 2026,
    prize: "30k Gift Reward",
    views: "2,559,578",
  },
  {
    name: "Kalyani Niwas Jadhav",
    month: "September",
    year: 2026,
    prize: "10k Gift Reward",
    views: "788,148",
  },
  {
    name: "Ashu Maurya",
    month: "September",
    year: 2026,
    prize: "10k Gift Reward",
    views: "772,309",
  },
  {
    name: "Sakshi Sanket Gawas",
    month: "September",
    year: 2026,
    prize: "10k Gift Reward",
    views: "761,925",
  },
  {
    name: "Mamta Shahu",
    month: "September",
    year: 2026,
    prize: "5k Gift Reward",
    views: "487,782",
  },
  {
    name: "Sonam Prashik Raut",
    month: "September",
    year: 2026,
    prize: "5k Gift Reward",
    views: "443,400",
  },
  {
    name: "Ashwini Jagtap",
    month: "September",
    year: 2026,
    prize: "5k Gift Reward",
    views: "340,769",
  },
  {
    name: "Chetana Agarwal",
    month: "September",
    year: 2026,
    prize: "5k Gift Reward",
    views: "320,144",
  },
  {
    name: "Palak Agrawal",
    month: "September",
    year: 2026,
    prize: "5k Gift Reward",
    views: "232,650",
  },
  {
    name: "Bhumika Vashishtha",
    month: "September",
    year: 2026,
    prize: "5k Gift Reward",
    views: "225,353",
  },
  {
    name: "Salma Naushad",
    month: "September",
    year: 2026,
    prize: "5k Gift Reward",
    views: "214,949",
  },
  {
    name: "Prachi Jadhav",
    month: "September",
    year: 2026,
    prize: "5k Gift Reward",
    views: "200,443",
  },
  {
    name: "Swati Kushwaha",
    month: "September",
    year: 2026,
    prize: "5k Gift Reward",
    views: "199,072",
  },
  {
    name: "Komal Sonkusare Rambhade",
    month: "September",
    year: 2026,
    prize: "5k Gift Reward",
    views: "190,157",
  },
  {
    name: "Dhanashri Shinde",
    month: "September",
    year: 2026,
    prize: "2k Gift Reward",
    views: "117,291",
  },
  {
    name: "Manali",
    month: "September",
    year: 2026,
    prize: "2k Gift Reward",
    views: "90,004",
  },
  {
    name: "Dibyadatta Pattanaik",
    month: "September",
    year: 2026,
    prize: "2k Gift Reward",
    views: "88,306",
  },
  {
    name: "Prabhavati Balasaheb Khalekar",
    month: "September",
    year: 2026,
    prize: "2k Gift Reward",
    views: "85,137",
  },
  {
    name: "Punam Sushant Kokate",
    month: "September",
    year: 2026,
    prize: "2k Gift Reward",
    views: "84,561",
  },
  {
    name: "Snehal Gawade",
    month: "September",
    year: 2026,
    prize: "2k Gift Reward",
    views: "79,369",
  },
  {
    name: "Rojalin Patra",
    month: "September",
    year: 2026,
    prize: "2k Gift Reward",
    views: "74,392",
  },
  {
    name: "Anita Ronit Aahara",
    month: "September",
    year: 2026,
    prize: "2k Gift Reward",
    views: "66,153",
  },
  {
    name: "Sandhya Kondlekar",
    month: "September",
    year: 2026,
    prize: "2k Gift Reward",
    views: "65,715",
  },
  {
    name: "Madhu M",
    month: "September",
    year: 2026,
    prize: "2k Gift Reward",
    views: "63,619",
  },

  // October 2026 Winners Data
  {
    name: "Nazia Chauhan",
    month: "October",
    year: 2026,
    prize: "Tablet",
    views: "29,193,485",
  },
  {
    name: "Honey Shaikh",
    month: "October",
    year: 2026,
    prize: "Tablet",
    views: "17,544,292",
  },
  {
    name: "Jyoti Sharma",
    month: "October",
    year: 2026,
    prize: "Tablet",
    views: "10,925,113",
  },
  {
    name: "Krishna Choudhary",
    month: "October",
    year: 2026,
    prize: "30k Gift Reward",
    views: "58,462,179",
  },
  {
    name: "Iqra Usmani",
    month: "October",
    year: 2026,
    prize: "30k Gift Reward",
    views: "4,802,947",
  },
  {
    name: "Pinki Kumari",
    month: "October",
    year: 2026,
    prize: "30k Gift Reward",
    views: "4,518,618",
  },
  {
    name: "Baishnabi Parida",
    month: "October",
    year: 2026,
    prize: "10k Gift Reward",
    views: "826,210",
  },
  {
    name: "Jyoti Singh",
    month: "October",
    year: 2026,
    prize: "10k Gift Reward",
    views: "797,168",
  },
  {
    name: "Kulsum Khatri",
    month: "October",
    year: 2026,
    prize: "10k Gift Reward",
    views: "748,111",
  },
  {
    name: "Parvati Vishwakarma",
    month: "October",
    year: 2026,
    prize: "5k Gift Reward",
    views: "460,767",
  },
  {
    name: "Kalyani Pradeep Salaskar",
    month: "October",
    year: 2026,
    prize: "5k Gift Reward",
    views: "440,096",
  },
  {
    name: "Nirmala Chandrakant Patil",
    month: "October",
    year: 2026,
    prize: "5k Gift Reward",
    views: "389,393",
  },
  {
    name: "Raju Kumar",
    month: "October",
    year: 2026,
    prize: "5k Gift Reward",
    views: "377,693",
  },
  {
    name: "Atiya Gani",
    month: "October",
    year: 2026,
    prize: "5k Gift Reward",
    views: "333,610",
  },
  {
    name: "Shraddha Tak",
    month: "October",
    year: 2026,
    prize: "5k Gift Reward",
    views: "308,517",
  },
  {
    name: "Sajeda",
    month: "October",
    year: 2026,
    prize: "5k Gift Reward",
    views: "290,219",
  },
  {
    name: "Shakahari Kitchen",
    month: "October",
    year: 2026,
    prize: "5k Gift Reward",
    views: "282,656",
  },
  {
    name: "Puja Saha",
    month: "October",
    year: 2026,
    prize: "5k Gift Reward",
    views: "236,185",
  },
  {
    name: "Vandana Shivaji Mohite",
    month: "October",
    year: 2026,
    prize: "5k Gift Reward",
    views: "176,954",
  },
  {
    name: "Shama Parveen",
    month: "October",
    year: 2026,
    prize: "2k Gift Reward",
    views: "87,213",
  },
  {
    name: "Kalyani Jadhav",
    month: "October",
    year: 2026,
    prize: "2k Gift Reward",
    views: "86,846",
  },
  {
    name: "Mamta Pareek",
    month: "October",
    year: 2026,
    prize: "2k Gift Reward",
    views: "86,338",
  },
  {
    name: "Swati Kushwaha",
    month: "October",
    year: 2026,
    prize: "2k Gift Reward",
    views: "83,544",
  },
  {
    name: "Riya Kumari",
    month: "October",
    year: 2026,
    prize: "2k Gift Reward",
    views: "79,179",
  },
  {
    name: "Pooja Shashank Sahu",
    month: "October",
    year: 2026,
    prize: "2k Gift Reward",
    views: "74,601",
  },
  {
    name: "Shefali Chakrawal",
    month: "October",
    year: 2026,
    prize: "2k Gift Reward",
    views: "70,749",
  },
  {
    name: "Reshma M",
    month: "October",
    year: 2026,
    prize: "2k Gift Reward",
    views: "60,252",
  },
  {
    name: "Ritesh Bhagwat Motekar",
    month: "October",
    year: 2026,
    prize: "2k Gift Reward",
    views: "56,423",
  },
  {
    name: "Shweta Mishra",
    month: "October",
    year: 2026,
    prize: "2k Gift Reward",
    views: "54,251",
  },
];
